module.exports = __webpack_public_path__ + "static/together_event02_img-b71aaed24074e47465448443e80c850d.png";